<template>
  <v-container fluid>
    <register-event/>
  </v-container>
</template>

<script>
  export default {
    name: 'NewEvent',
    components: {
      RegisterEvent: () => import ('@/components/events_agenda/RegisterEvent.vue')
    },
  }
</script>

<style lang="scss" scoped>

</style>